package one.healthium.profile.ui.update_age

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.UserProfileOptions
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class UpdateAgeViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(UpdateAgeUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()
    val events = EventProducer<UpdateAgeEvent>()

    init {
        userInteractor.observeUser()
            .onEach { userModel ->
                _state.update { state ->
                    state.copy(userModel = userModel)
                }
            }
            .launch()
    }

    fun onAgeChanged(value: Int) {
        _state.value = _state.value.copy(updatedAge = value)
    }

    fun onSaveClicked() {
        val updatedAge = _state.value.updatedAge
        if (_state.value.isAgeChanged.not() || updatedAge == null || _state.value.isAgeValid.not()) {
            events.trigger(UpdateAgeEvent.OnAgeUpdated)
            return
        }

        launch {
            _state.update { state -> state.copy(loading = true) }
            try {
                userInteractor.updateUserProfile(
                    UserProfileOptions(age = updatedAge)
                )
                events.trigger(UpdateAgeEvent.OnAgeUpdated)
            } catch (e: Exception) {
                Logger.e(e) { "Failed to update age" }
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }
}